"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asTypedEventEmitter = void 0;
/** cast type of any event emitter to typed event emitter */
function asTypedEventEmitter(x) {
    return x;
}
exports.asTypedEventEmitter = asTypedEventEmitter;
//# sourceMappingURL=types.js.map